export type CollectionPost = {
    id: number;
    content: string;
    category?: string | null;
    truthVoteCount?: number;
    lieVoteCount?: number;
    commentCount?: number;
};

export type TopicCollection = {
    name: string;
    label: string;
    question: string;
    lens: string;
    posts: CollectionPost[];
};

const EDITORIAL: Record<string, { question: string; lens: string }> = {
    AI: { question: '기술이 바꾸는 일상에서, 우리는 무엇을 직접 선택해야 할까요?', lens: '기대와 걱정을 나누어 읽어보세요.' },
    사회: { question: '사람과 관계에 대한 판단은 어디에서 달라질까요?', lens: '경험과 일반화 사이의 거리를 살펴보세요.' },
    괴담: { question: '설명되지 않은 장면을 만나면 무엇부터 확인할까요?', lens: '관찰된 장면과 상상한 결론을 나누어 보세요.' },
    미스터리: { question: '이야기 속 단서와 추측은 어떻게 구분할까요?', lens: '확실한 정보와 열린 질문을 따로 읽어보세요.' },
    과학: { question: '놀라운 과학 이야기는 어떤 근거로 확인할까요?', lens: '숫자와 출처, 비교 대상을 먼저 찾아보세요.' },
    경제: { question: '일상의 선택은 어떤 기준에서 달라질까요?', lens: '상황과 가치관이 결론에 미치는 영향을 생각해 보세요.' },
    퀴즈: { question: '정답을 고르기 전에 놓친 단서는 없을까요?', lens: '직감과 실제 근거를 비교해 보세요.' },
    실화: { question: '경험담에서 확인할 수 있는 부분은 어디까지일까요?', lens: '직접 겪은 일과 해석을 구분해 읽어보세요.' }
};

export const collectionHref = (category: string) => `#/collections?topic=${encodeURIComponent(category)}`;

export function buildCollections(posts: CollectionPost[]): TopicCollection[] {
    const byCategory = new Map<string, CollectionPost[]>();
    for (const post of posts) {
        const name = post.category?.trim();
        if (!name || !Number.isFinite(post.id)) continue;
        byCategory.set(name, [...(byCategory.get(name) || []), post]);
    }
    return Array.from(byCategory, ([name, items]) => {
        const editorial = EDITORIAL[name] || {
            question: `${name === 'free' ? '자유' : name} 이야기는 어떤 시선에서 다르게 보일까요?`,
            lens: '주장과 의견을 구분하고, 궁금한 점을 찾아보세요.'
        };
        return {
            name,
            label: name === 'free' ? '자유' : name,
            ...editorial,
            posts: [...items].sort((a, b) => b.id - a.id)
        };
    }).filter((collection) => collection.posts.length >= 2)
      .sort((a, b) => b.posts[0].id - a.posts[0].id);
}
